/* Mama's Daily — shared JS (Horizon compatible).
   Option/variant picker propagates the selected variant id to every add-to-cart
   button, swaps the variant image, updates the money price and sold-out state,
   and adds to the Horizon cart drawer. Loaded once (module URL de-dupes). */

(function () {
  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  function init() { galleries(); thumbNav(); calculators(); packs(); faqs(); reveals(); stickyBar(); atc(); addons(); reviews(); }

  /* ---- gallery ---- */
  function galleries() {
    $$('[data-md-thumbs]').forEach((thumbs) => {
      const main = document.getElementById(thumbs.getAttribute('data-main') || 'md-mainImg');
      $$('button', thumbs).forEach((b) => {
        if (!once(b, 'mdThumb')) return;
        b.addEventListener('click', () => {
          $$('button', thumbs).forEach((x) => x.classList.remove('active'));
          b.classList.add('active');
          if (!main || !b.dataset.src) return;
          main.style.opacity = 0;
          setTimeout(() => { main.src = b.dataset.src; main.style.opacity = 1; }, 180);
        });
      });
    });
  }

  /* ---- side thumbnail slider arrows ---- */
  function thumbNav() {
    $$('[data-md-thumb-nav]').forEach((btn) => {
      if (!once(btn, 'mdNavBound')) return;
      btn.addEventListener('click', () => {
        const col = btn.closest('.thumbs-col') || btn.parentElement;
        const list = col ? col.querySelector('.thumbs') : null;
        if (!list) return;
        const dir = parseInt(btn.dataset.mdThumbNav, 10) || 1;
        const horizontal = getComputedStyle(list).flexDirection === 'row';
        if (horizontal) list.scrollBy({ left: dir * 180, behavior: 'smooth' });
        else list.scrollBy({ top: dir * 180, behavior: 'smooth' });
      });
    });
  }

  /* ---- savings calculator ---- */
  function calculators() {
    $$('.md-calc').forEach((calc) => {
      const spend = $('input[type=range]', calc);
      if (!spend || !once(calc, 'mdCalc')) return;
      const WASTE = parseFloat(calc.dataset.waste) || 0.35;
      const SET   = parseFloat(calc.dataset.setprice) || 29.99;
      const HALVE = parseFloat(calc.dataset.halve) || 0.5;
      const CUR = calc.dataset.cur || '$';
      const ISO = calc.dataset.iso || '';
      const LOC = calc.dataset.locale || 'en';
      let fmt;
      try {
        const nf = new Intl.NumberFormat(LOC, { style: 'currency', currency: ISO, minimumFractionDigits: 0, maximumFractionDigits: 0 });
        nf.format(1);
        fmt = (n) => nf.format(Math.round(n));
      } catch (e) {
        fmt = (n) => CUR + Math.round(n).toLocaleString(LOC);
      }
      const upd = () => {
        const w = +spend.value;
        const sv = $('[data-md-spendval]', calc); if (sv) sv.textContent = fmt(w);
        const waste = w * 52 * WASTE, saved = waste * HALVE;
        const wy = $('[data-md-wasteyear]', calc); if (wy) wy.textContent = fmt(waste);
        const syn = $('[data-md-saveyear]', calc); if (syn) syn.textContent = fmt(saved);
        const wk = SET / (saved / 52);
        const pb = $('[data-md-payback]', calc);
        if (pb) pb.textContent = wk < 1 ? 'under a week' : (wk < 8 ? 'under ' + Math.ceil(wk) + ' weeks' : Math.round(wk) + ' weeks');
      };
      spend.addEventListener('input', upd); upd();
    });
  }

  /* ---- option / variant picker ---- */
  function getSelectedPack() { return document.querySelector('.hopt.pick') || document.querySelector('.hopt'); }

  function applyPack(el) {
    if (!el) return;
    $$('.hopt').forEach((t) => t.classList.remove('pick'));
    el.classList.add('pick');
    const d = el.dataset;

    const pv = parseFloat(d.price), wv = parseFloat(d.was);
    const pct = (wv > 0 && wv > pv) ? Math.round((1 - pv / wv) * 100) : 0;
    const priceStr = d.priceMoney || (isNaN(pv) ? '' : '$' + pv.toFixed(2));
    const wasStr = d.wasMoney || (isNaN(wv) ? '' : '$' + wv.toFixed(2));

    const setId = (id, v) => { const n = document.getElementById(id); if (n) n.textContent = v; };
    setId('md-ctaPrice', priceStr);
    $$('[data-md-sticky-name]').forEach((n) => n.textContent = d.stickyname || ('Fresh-Keeper · Pack of ' + (d.count || '')));
    $$('[data-md-sticky-price]').forEach((n) => n.textContent = priceStr);
    $$('[data-md-sticky-was]').forEach((n) => n.textContent = wasStr);
    $$('.badge-save').forEach((b) => {
      if (pct > 0) { b.textContent = 'Save ' + pct + '%'; b.style.display = ''; }
      else { b.textContent = ''; b.style.display = 'none'; }
    });

    // real variant → every add-to-cart button
    if (d.variantId) $$('[data-md-atc]').forEach((b) => { b.dataset.variant = d.variantId; });

    // variant image swap
    if (d.mediaSrc) {
      const main = document.getElementById('md-mainImg');
      if (main) { main.style.opacity = 0; setTimeout(() => { main.src = d.mediaSrc; main.style.opacity = 1; }, 180); }
    }

    // sold-out state
    const soldout = d.available === 'false';
    $$('[data-md-atc]').forEach((b) => { b.disabled = soldout; b.style.opacity = soldout ? '.55' : ''; });
  }

  function packs() {
    $$('.hopt').forEach((el) => { if (once(el, 'mdPack')) el.addEventListener('click', () => applyPack(el)); });
    const sel = getSelectedPack(); if (sel) applyPack(sel);
  }

  /* ---- faq ---- */
  function faqs() {
    $$('.faq-q').forEach((btn) => {
      if (!once(btn, 'mdFaq')) return;
      btn.addEventListener('click', () => {
        const item = btn.parentElement, a = item.querySelector('.faq-a');
        if (item.classList.contains('open')) { item.classList.remove('open'); a.style.maxHeight = null; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* ---- reveal ---- */
  function reveals() {
    const ro = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); }
    }), { threshold: 0.12 });
    $$('.reveal').forEach((r) => { if (once(r, 'mdReveal')) ro.observe(r); });
  }

  /* ---- sticky bar ---- */
  function stickyBar() {
    const bar = document.getElementById('md-stickyBar');
    if (!bar || !once(bar, 'mdSticky')) return;
    const hero = document.getElementById('md-buy');
    if (hero) {
      new IntersectionObserver(([e]) => {
        if (e.boundingClientRect.top < 0 && !e.isIntersecting) bar.classList.add('show');
        else bar.classList.remove('show');
      }, { threshold: 0 }).observe(hero);
    } else {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 600) bar.classList.add('show'); else bar.classList.remove('show');
      }, { passive: true });
    }
  }

  /* ---- add-on offer (checkbox beside the main CTA) ---- */
  function addons() {
    $$('[data-md-addon-check]').forEach((cb) => {
      if (!once(cb, 'mdAddonBound')) return;
      const row = cb.closest('[data-md-addon]');
      const sync = () => { if (row) row.classList.toggle('is-on', cb.checked); };
      cb.addEventListener('change', sync);
      sync();
    });
  }

  function addonLines() {
    return $$('[data-md-addon-check]')
      .filter((cb) => cb.checked && cb.dataset.variant)
      .map((cb) => ({ id: Number(cb.dataset.variant), quantity: Number(cb.dataset.qty) || 1 }));
  }

  /* ---- add to cart ---- */
  function atc() {
    $$('[data-md-atc]').forEach((btn) => {
     if (!once(btn, 'mdAtcBound')) return;
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        const pack = getSelectedPack();
        const qty = Number(pack && pack.dataset.qty) || Number(btn.dataset.qty) || 1;
        const variant = btn.dataset.variantOverride || btn.dataset.variant;
        if (!variant) { window.location.href = '/cart'; return; }

        const lines = [{ id: Number(variant), quantity: qty }].concat(addonLines());
        addToCart(lines, btn);
      });
    });
  }

  /* ---- quick add (cart drawer upsell) ----
     Delegated, because the drawer is replaced wholesale by the Section Rendering
     API on every cart update and would lose directly bound listeners. */
  function quickAdd(ev) {
    const btn = ev.target.closest('[data-md-quick-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    const variant = btn.dataset.variant;
    if (!variant) return;
    addToCart([{ id: Number(variant), quantity: Number(btn.dataset.qty) || 1 }], btn);
  }
  document.addEventListener('click', quickAdd);

  /* ---- Horizon cart drawer add-to-cart ---- */
  let _events;
  async function getEvents() {
    if (_events !== undefined) return _events;
    try { _events = await import('@shopify/events'); } catch (e) { _events = null; }
    return _events;
  }

  /**
   * Adds one or more lines in a single request.
   * @param {Array<{id:number, quantity:number}>} lines
   * @param {HTMLElement} [btn] button to put into a loading state
   */
  async function addToCart(lines, btn) {
    if (!Array.isArray(lines) || !lines.length) return;

    const original = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    const baseUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';
    const addUrl = baseUrl.replace(/\.js$/, '') + '.js';
    const totalQty = lines.reduce((n, l) => n + (l.quantity || 1), 0);

    try {
      const ev = await getEvents();
      const ids = [];
      document.querySelectorAll('cart-items-component').forEach((i) => { if (i.dataset.sectionId) ids.push(i.dataset.sectionId); });

      const payload = { items: lines };
      if (ids.length) payload.sections = ids.join(',');

      let deferred = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          deferred = ev.CartLinesUpdateEvent.createPromise();
          document.dispatchEvent(new ev.CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
            promise: deferred.promise,
          }));
        } catch (e) { deferred = null; }
      }

      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (!res.ok || data.status) {
        if (deferred && deferred.reject) deferred.reject(new Error(data.message || 'add failed'));
        notify(data.description || data.message || 'Sorry, this could not be added to the cart.', true);
        return;
      }

      // The add-on is in the cart now, so untick it: a second Add to cart click
      // should not silently add it again.
      const added = new Set(lines.map((l) => String(l.id)));
      $$('[data-md-addon-check]').forEach((cb) => {
        if (cb.checked && added.has(String(cb.dataset.variant))) {
          cb.checked = false;
          cb.dispatchEvent(new Event('change'));
        }
      });

      if (deferred && deferred.resolve && ev.CartLinesUpdateEvent.createCartFromAjaxResponse) {
        try {
          const cart = await (await fetch('/cart.js')).json();
          deferred.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { didError: false, items: cart.items, source: 'mamas-daily', itemCount: totalQty },
            sections: data.sections,
          });
        } catch (e) {
          try { deferred.resolve({ detail: { didError: false, itemCount: totalQty } }); } catch (_) {}
          await refreshDrawer();
        }
        openDrawer();
      } else {
        await refreshDrawer(); await refreshCount(); openDrawer();
      }
    } catch (e) {
      await refreshDrawer(); await refreshCount(); openDrawer();
    } finally {
      if (btn) { btn.disabled = false; if (original !== null) btn.innerHTML = original; }
    }
  }

  async function refreshDrawer() {
    try {
      const wrap = document.getElementById('shopify-section-cart-drawer-section');
      if (!wrap) return;
      const html = await (await fetch('/?section_id=cart-drawer-section')).text();
      if (html && html.trim()) wrap.innerHTML = html;
    } catch (e) {}
  }
  async function refreshCount() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.cart-bubble, [data-cart-count], .cart-count').forEach((el) => {
        el.textContent = cart.item_count; el.removeAttribute('hidden');
      });
    } catch (e) {}
  }
  function openDrawer() {
    const drawer = document.getElementById('cart-drawer');
    try { if (drawer && typeof drawer.open === 'function') { if (!drawer.isOpen) drawer.open(); return; } } catch (e) {}
    const trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
  }

  /* ---- toast (replaces alert() for cart errors) ---- */
  function notify(message, isError) {
    let el = document.getElementById('md-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'md-toast';
      el.className = 'mdp md-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('show');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('show'), 5000);
  }

  /* ---- reviews widget ---- */
  function reviews() {
    $$('[data-md-reviews]').forEach((root) => {
    if (!once(root, 'mdReviewsBound')) return;

      const grid = $('[data-md-rev-grid]', root);
      if (!grid) return;

      const cards = $$('.md-rev-card', grid);
      const moreBtn = $('[data-md-rev-more]', root);
      const showing = $('[data-md-rev-showing]', root);
      const noneMsg = $('[data-md-rev-none]', root);
      const sortSel = $('[data-md-sort]', root);
      const perPage = Math.max(1, parseInt(root.dataset.perPage, 10) || 9);

      // Filter buttons live both in the toolbar and in the summary distribution
      // bars, which sit outside this element — scope to the whole section.
      const section = root.closest('.md-rev') || root;
      const filterBtns = $$('[data-md-filter]', section);

      let filter = 'all';
      let shown = perPage;

      const ts = (card) => {
        const t = Date.parse(card.dataset.date || '');
        return isNaN(t) ? null : t;
      };
      const idx = (card) => parseInt(card.dataset.index, 10) || 0;
      const rating = (card) => parseInt(card.dataset.rating, 10) || 0;
      const hasPhoto = (card) => card.dataset.photo === '1';

      const matches = (card) => {
        if (filter === 'all') return true;
        if (filter === 'photo') return hasPhoto(card);
        return String(rating(card)) === filter;
      };

      const comparators = {
        featured: (a, b) => idx(a) - idx(b),
        highest: (a, b) => rating(b) - rating(a) || idx(a) - idx(b),
        lowest: (a, b) => rating(a) - rating(b) || idx(a) - idx(b),
        photos: (a, b) => (hasPhoto(b) ? 1 : 0) - (hasPhoto(a) ? 1 : 0) || idx(a) - idx(b),
        newest: (a, b) => {
          const ta = ts(a);
          const tb = ts(b);
          if (ta === null && tb === null) return idx(a) - idx(b);
          if (ta === null) return 1;
          if (tb === null) return -1;
          return tb - ta;
        },
      };

      function render() {
        const visible = cards.filter(matches);
        const sorted = visible.slice().sort(comparators[(sortSel && sortSel.value) || 'featured']);

        // Re-append in sorted order. Cards already in position are not moved,
        // so this stays cheap even with a few hundred reviews.
        sorted.forEach((card) => grid.appendChild(card));

        cards.forEach((card) => { card.hidden = true; });
        sorted.slice(0, shown).forEach((card) => { card.hidden = false; });

        const visibleCount = Math.min(shown, sorted.length);
        if (noneMsg) noneMsg.hidden = sorted.length !== 0;
        if (moreBtn) moreBtn.hidden = sorted.length <= shown;
        if (showing) {
          showing.textContent = sorted.length
            ? 'Showing ' + visibleCount + ' of ' + sorted.length + (sorted.length === 1 ? ' review' : ' reviews')
            : '';
        }
      }

      filterBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const next = btn.dataset.mdFilter;
          // Clicking the active star filter a second time clears it.
          filter = filter === next && next !== 'all' ? 'all' : next;
          shown = perPage;
          $$('.md-rev-pill', section).forEach((p) => p.classList.toggle('is-on', p.dataset.mdFilter === filter));
          $$('.md-rev-bar', section).forEach((p) => p.classList.toggle('is-on', p.dataset.mdFilter === filter));
          render();
        });
      });

      if (sortSel) sortSel.addEventListener('change', () => { shown = perPage; render(); });

      if (moreBtn) {
        moreBtn.addEventListener('click', () => {
          shown += perPage;
          render();
          // Move focus to the first newly revealed card for keyboard users.
          const next = cards.filter((c) => !c.hidden).slice(-1)[0];
          if (next) next.setAttribute('tabindex', '-1'), next.focus({ preventScroll: true });
        });
      }

      // Photo lightbox
      const box = $('[data-md-rev-lightbox]', section);
      if (box) {
        const boxImg = $('img', box);
        const close = $('[data-md-rev-lightbox-close]', box);
        $$('[data-md-rev-photo]', grid).forEach((btn) => {
          btn.addEventListener('click', () => {
            const img = $('img', btn);
            if (!img || !boxImg) return;
            boxImg.src = img.currentSrc || img.src;
            boxImg.alt = img.alt || '';
            if (typeof box.showModal === 'function') box.showModal();
          });
        });
        if (close) close.addEventListener('click', () => box.close());
        box.addEventListener('click', (e) => { if (e.target === box) box.close(); });
      }

      render();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();